import type { BoxProps } from '@withjoy/joykit';
import { Box, styled, css } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const Root = styled(Box)``;

const navBackdrop = css`
  background-color: rgba(255, 255, 255, 0.92);

  /* if backdrop support: very transparent and blurred */
  @supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
    backdrop-filter: saturate(180%) blur(20px);
  }
`;

export const NavContainer = styled(Box)<{ $isOpen: boolean }>`
  position: relative;
  z-index: 2;

  ${({ theme, $isOpen }) => {
    return $isOpen
      ? {
          backgroundColor: theme.colors.white,
        }
      : navBackdrop;
  }}
`;

// The shadow only exists while open: the closed panel is parked just above the nav (and always
// mounted on mobile), where it would otherwise bleed over the bar.
export const DropdownLinksContainer = styled(Box)<{ $isOpen: boolean }>`
  position: absolute;
  width: 100%;
  left: 0;
  background-color: white;
  z-index: 3;
  ${({ theme, $isOpen }) => ($isOpen ? { boxShadow: `0 50px 100px -20px ${theme.colors.mono14}0D, 0 30px 60px -30px ${theme.colors.mono14}0F` } : null)}
`;

export const MEGANAV_STYLE_OVERRIDES: BoxProps = {
  alignItems: 'center',
  justifyContent: 'space-between',
  columnGap: 5,
  height: pxToRem(80),
  width: '100%',
  marginX: [null, null, null, null, 'auto'],
  paddingX: {
    _: 0,
    sm2: 7,
  },
};
